import React from 'react';

import PropTypes from 'prop-types';
import { Checkbox } from '@tfecom-thermofisher/react-komodo-design';

const SelectAllContainer = ({
  setSelectedItems,
  selectedItemsIds,
  itemsIds,
}) => {
  const toggleSelectAll = () => {
    const checked = itemsIds.length === selectedItemsIds.length;

    setSelectedItems(checked ? [] : itemsIds);
  };

  return (
    <Checkbox
      data-testid="qa-header-checkbox"
      checked={itemsIds.length === selectedItemsIds.length}
      onChange={toggleSelectAll}
    />
  );
};

SelectAllContainer.propTypes = {
  itemsIds: PropTypes.array.isRequired,
  selectedItemsIds: PropTypes.array.isRequired,
  setSelectedItems: PropTypes.func.isRequired,
};

export default SelectAllContainer;
